import { SubAgentSpawnCard } from './subagent-spawn-card';
import { SubAgentRunCard } from './subagent-run-card';
import { InlineToolCall } from './inline-tool-call';

/**
 * Routes a tool-call part to the correct component based on toolName.
 * Shared between AgentChainOfThought and ThoughtsPanel (thinking-timeline).
 */
export function ToolCallRouter(props: Record<string, unknown>) {
  const toolName = String(props.toolName ?? '');

  if (toolName === '__subagent_spawn') {
    return (
      <SubAgentSpawnCard
        args={(props.args as Record<string, unknown>) ?? {}}
        result={props.result}
      />
    );
  }

  if (toolName === '__subagent_run') {
    return (
      <SubAgentRunCard
        args={(props.args as Record<string, unknown>) ?? {}}
        result={props.result}
        isError={!!props.isError}
      />
    );
  }

  return (
    <InlineToolCall
      toolName={toolName}
      toolDisplayName={props.toolDisplayName ? String(props.toolDisplayName) : undefined}
      toolCallId={String(props.toolCallId ?? '')}
      args={(props.args as Record<string, unknown>) ?? {}}
      result={props.result}
      isError={!!props.isError}
      status={props.status as { type: string } | undefined}
      durationMs={typeof props.durationMs === 'number' ? (props.durationMs as number) : undefined}
    />
  );
}
